import { render, staticRenderFns } from "./IcoFilePrev.vue?vue&type=template&id=7a35ff4c&lang=html"
import script from "./IcoFilePrev.vue?vue&type=script&lang=js"
export * from "./IcoFilePrev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports